import { createSelector } from "@reduxjs/toolkit";

import { selectFacetedResults } from "./select-faceted-results";

export const selectMatchedResults = createSelector(
	[selectFacetedResults],
	(facetedResults) => {
		return facetedResults?.MatchedResults;
	},
);
